import axios from "axios";

const API_URL = "https://clpprojectworkplace.com/api/";
// const API_URL = "http://localhost:7071/";

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 100000,
});

const handleApiError = (error) => {
  if (error.response) {
    console.error("API Error:", error.response.status, error.response.data);
  } else if (error.request) {
    console.error("No response received:", error.request);
  } else {
    console.error("Error setting up request:", error.message);
  }
  return error;
};

export const get = async (url, config = {}) => {
  try {
    await refreshToken();
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    const response = await apiClient.get(url, {
      ...config,
      headers: {
        ...config.headers,
        ...headers,
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const post = async (url, data, config = {}) => {
  try {
    if (!url.includes("auth/token/refresh")) {
      await refreshToken();
    }
    const headers = {
      ...(data instanceof FormData
        ? { "Content-Type": "multipart/form-data", Authorization: `Bearer ${localStorage.getItem("token")}` }
        : { Authorization: `Bearer ${localStorage.getItem("token")}` }),
    };

    const response = await apiClient.post(url, data, {
      ...config,
      headers: {
        ...headers,
        ...config.headers,
      },
    });

    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const del = async (url, config = {}) => {
  try {
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };
    const response = await apiClient.delete(url, {
      ...config,
      headers: {
        ...config.headers,
        ...headers,
      },
    });
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

let refreshPromise = null;

const refreshToken = async () => {
  // Check if token needs to be refreshed
  if (localStorage.getItem("exp") && localStorage.getItem("exp") < new Date().getTime() && localStorage.getItem("refreshToken")) {
    // If a refresh is already in progress, return the same promise
    if (refreshPromise) {
      return refreshPromise;
    }
    // Start a new refresh and store the promise
    refreshPromise = post(`auth/token/refresh`, { token: localStorage.getItem("refreshToken") })
      .then((data) => {
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("exp", new Date().getTime() + 30 * 60 * 1000);
        localStorage.setItem("refreshToken", data.refresh_token);
        return data;
      })
      .catch((error) => {
        localStorage.removeItem("token");
        localStorage.removeItem("exp");
        localStorage.removeItem("refreshToken");
      })
      .finally(() => {
        refreshPromise = null; // Reset after done
      });
    return refreshPromise;
  }
  // If no refresh needed, return resolved promise
  return Promise.resolve();
};
